import sanityImgUtil from "utils/sanityImgUtil";

import { Image } from "types";

export default (
  image: Image,
  smImageWidth: number,
  mdImageWidth: number,
  lgImageWidth: number
): string => {
  if (!image) return "";

  const smImagePath = sanityImgUtil(image, smImageWidth);
  const mdImagePath = sanityImgUtil(image, mdImageWidth);
  const lgImagePath = sanityImgUtil(image, lgImageWidth);

  return `${smImagePath} ${smImageWidth}w, ${mdImagePath} ${mdImageWidth}w, ${lgImagePath} ${lgImageWidth}w`;
};
